/**
 * Which DevPulse feature works with which agent, said plainly. Kept in step with
 * docs/compatibility.md: "soon" is what that document calls possible but not built.
 */

import { Check, Clock3, Minus } from 'lucide-react'
import { useI18n } from '../lib/i18n'

type Support = 'yes' | 'soon' | 'no'

const AGENTS = ['Claude Code', 'Codex CLI', 'Cursor', 'Gemini CLI', 'Kiro', 'OpenCode'] as const

const FEATURES: Array<{ key: string; support: Support[] }> = [
  { key: 'room', support: ['yes', 'yes', 'yes', 'yes', 'yes', 'yes'] },
  { key: 'prompt', support: ['yes', 'soon', 'soon', 'soon', 'no', 'soon'] },
  { key: 'runner', support: ['yes', 'yes', 'no', 'no', 'no', 'no'] },
  { key: 'skills', support: ['yes', 'no', 'no', 'no', 'no', 'no'] },
  { key: 'telegram', support: ['yes', 'no', 'no', 'no', 'no', 'no'] },
]

export function AgentMatrix() {
  const { t } = useI18n()
  const icon = (support: Support) =>
    support === 'yes' ? <Check size={15} aria-label={t('matrix.yes')} /> : support === 'soon' ? <Clock3 size={14} aria-label={t('matrix.soon')} /> : <Minus size={14} aria-label={t('matrix.no')} />

  return (
    <div className="agent-matrix">
      <table>
        <thead>
          <tr>
            <th scope="col">{t('matrix.feature')}</th>
            {AGENTS.map((agent) => (
              <th key={agent} scope="col">{agent}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {FEATURES.map((feature) => (
            <tr key={feature.key}>
              <th scope="row">
                <span className="small">{t(`matrix.${feature.key}`)}</span>
                <span className="tiny muted">{t(`matrix.${feature.key}.what`)}</span>
              </th>
              {feature.support.map((support, i) => (
                <td key={AGENTS[i]} className={`agent-matrix__${support}`} title={t(`matrix.${support}`)}>
                  {icon(support)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="tiny muted">{t('matrix.legend')}</p>
    </div>
  )
}
